import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  message,
  Select,
  Switch,
  Spin,
  Row,
  Col,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { apiService } from "@/services/api";

const { Option } = Select;

export const UserEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const data = await apiService.getUser(id);
        form.setFieldsValue({
          username: data.username,
          email: data.email,
          firstName: data.firstName,
          lastName: data.lastName,
          phone: data.phone,
          roles: data.roles,
          enabled: data.enabled,
        });
      } catch (e: any) {
        message.error("Impossible de charger l'utilisateur");
      } finally {
        setFetching(false);
      }
    })();
  }, [id, form]);

  const onFinish = async (values: any) => {
    if (!id) return;
    try {
      setLoading(true);
      await apiService.updateUser(id, {
        username: values.username,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        roles: values.roles,
        enabled: values.enabled,
      });
      message.success("Utilisateur mis à jour avec succès");
      navigate("/users");
    } catch (e: any) {
      message.error(
        e?.response?.data?.message || "Erreur lors de la mise à jour"
      );
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Card title="Modifier l'utilisateur">
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nom d'utilisateur"
              name="username"
              rules={[{ required: true }]}
            >
              <Input placeholder="john_doe" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, type: "email" }]}
            >
              <Input placeholder="john.doe@filmika.io" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Prénom" name="firstName">
              <Input placeholder="John" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Nom" name="lastName">
              <Input placeholder="Doe" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Téléphone" name="phone">
          <Input placeholder="+33 6 12 34 56 78" />
        </Form.Item>

        <Form.Item
          label="Rôles"
          name="roles"
          rules={[{ required: true, message: "Au moins un rôle est requis" }]}
        >
          <Select
            mode="multiple"
            placeholder="Sélectionnez un ou plusieurs rôles"
            allowClear
          >
            <Option value="ADMIN">Administrateur</Option>
            <Option value="EDITOR">Éditeur</Option>
            <Option value="AUTHOR">Auteur</Option>
            <Option value="REVIEWER">Réviseur (lecture seule)</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Compte activé" name="enabled" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Button type="primary" htmlType="submit" loading={loading}>
          Enregistrer les modifications
        </Button>
      </Form>
    </Card>
  );
};

export default UserEdit;
